import { SEARCHMEMBER_FAIL, SEARCHMEMBER_SUCCESS } from '../actionTypes';

const initialState = {
    user: null
};

const searchMemberReducer = (state = initialState, action) => {
    switch (action.type) {
        case SEARCHMEMBER_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case SEARCHMEMBER_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default searchMemberReducer;
